import { addDays } from 'date-fns/addDays';
import { addMonths } from 'date-fns/addMonths';
import { endOfDay } from 'date-fns/endOfDay';
import { endOfMonth } from 'date-fns/endOfMonth';
import { formatISO } from 'date-fns/formatISO';
import { startOfDay } from 'date-fns/startOfDay';
import { startOfMonth } from 'date-fns/startOfMonth';
import { MBox } from '../../../components/Monetize';
import DataTableActions from '../../../components/Monetize/DataTable/MDataTableActions';

interface UsageManagementActionsProps {
  onChangeDateRange: (startTime: string, endTime: string) => void;
}

export const UsageManagementActions = ({
  onChangeDateRange,
}: UsageManagementActionsProps) => {
  return (
    <MBox ml={2}>
      <DataTableActions
        actions={[
          {
            title: 'Current Month',
            enabled: true,
            action: () => {
              const startTime = startOfMonth(new Date());
              const endTime = endOfMonth(startTime);
              onChangeDateRange(formatISO(startTime), formatISO(endTime));
            },
          },
          {
            title: 'Previous Month',
            enabled: true,
            hasBottomDivider: true,
            action: () => {
              const startTime = startOfMonth(addMonths(new Date(), -1));
              const endTime = endOfMonth(startTime);
              onChangeDateRange(formatISO(startTime), formatISO(endTime));
            },
          },
          {
            title: 'Last 7 Days',
            enabled: true,
            action: () => {
              const startTime = startOfDay(addDays(new Date(), -7));
              const endTime = endOfDay(new Date());
              onChangeDateRange(formatISO(startTime), formatISO(endTime));
            },
          },
          {
            title: 'Last 30 Days',
            enabled: true,
            action: () => {
              const startTime = startOfDay(addDays(new Date(), -30));
              const endTime = endOfDay(new Date());
              onChangeDateRange(formatISO(startTime), formatISO(endTime));
            },
          },
          {
            title: 'Last 60 Days',
            enabled: true,
            action: () => {
              const startTime = startOfDay(addDays(new Date(), -60));
              const endTime = endOfDay(new Date());
              onChangeDateRange(formatISO(startTime), formatISO(endTime));
            },
          },
        ]}
      />
    </MBox>
  );
};
